import { render, staticRenderFns } from "./down.vue?vue&type=template&id=776a0295&scoped=true&"
import script from "./down.vue?vue&type=script&lang=js&"
export * from "./down.vue?vue&type=script&lang=js&"
import style0 from "./down.vue?vue&type=style&index=0&id=776a0295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a0295",
  null
  
)

export default component.exports